
import { OnboardingData } from './types'

// Handle input change
export function handleInputChange(
  field: keyof OnboardingData,
  value: string | number | null,
  setData: React.Dispatch<React.SetStateAction<OnboardingData>>,
  setError: React.Dispatch<React.SetStateAction<string | null>>
) {
  setData(prev => ({ ...prev, [field]: value }))
  setError(null)
}

// Handle next step
export function handleNext(
  currentStep: number,
  totalSteps: number,
  data: OnboardingData,
  setError: React.Dispatch<React.SetStateAction<string | null>>,
  navigate: (path: string) => void,
  handleSubmit: (e: React.FormEvent) => Promise<void>
) {
  // Validate current step
  if (currentStep === 1) {
    if (!data.firstName.trim() || !data.lastName.trim()) {
      setError('Please fill in all required fields')
      return
    }
    // Validate phone if provided (E.164 format validation)
    if (data.phone && !data.phone.startsWith('+')) {
      setError('Please enter a valid phone number')
      return
    }
    // Move to step 2
    setError(null)
    navigate('/onboarding/step-2')
  } else if (currentStep === 2) {
    // Move to step 3
    setError(null)
    navigate('/onboarding/step-3')
  } else if (currentStep === 3) {
    // Step 3 is the final step - submit the form
    handleSubmit(new Event('submit') as React.FormEvent<HTMLFormElement>)
  }
}

// Handle back step
export function handleBack(
  currentStep: number,
  navigate: (path: string) => void,
  setError: React.Dispatch<React.SetStateAction<string | null>>
) {
  const prevStep = Math.max(currentStep - 1, 1)
  navigate(`/onboarding/step-${prevStep}`)
  setError(null)
}
